// Hover-magnifier zoom for the Newegg gallery. Pointer-fine only; lens/panel
// append to <body> so overflow:hidden ancestors (Safari sticky) can't clip them.
(() => {
  const init = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    const gallery = document.querySelector(
      '.section-product-template-newegg-style .newegg-product-layout__gallery'
    );
    if (!gallery) return;

    const items = gallery.querySelectorAll('.slider-item[data-src]');
    if (!items.length) return;

    const ZOOM = 2.5;
    const MIN_PANEL_W = 320;
    const MIN_PANEL_H = 320;
    const FALLBACK_GAP = 24;
    // Keep the original preview height even when the sticky header is showing —
    // the panel stacks above the header (z-index), so we don't shrink for it.
    const VIEWPORT_TOP = 96;
    const VIEWPORT_BOTTOM_MARGIN = 24;

    const layout = gallery.parentElement;

    const lens = document.createElement('div');
    lens.className = 'newegg-zoom-lens';
    lens.hidden = true;

    const panel = document.createElement('div');
    panel.className = 'newegg-zoom-panel';
    panel.hidden = true;

    document.body.append(lens, panel);

    let activeImg = null;
    let activeSrc = null;
    let panelW = 0;
    let panelH = 0;
    let lensW = 0;
    let lensH = 0;
    let lastClientX = 0;
    let lastClientY = 0;

    const sizePanelAndLens = () => {
      const galleryRect = gallery.getBoundingClientRect();
      const layoutRect = (layout || gallery).getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(layout || gallery).columnGap) || FALLBACK_GAP;
      const vh = document.documentElement.clientHeight;

      const left = Math.round(galleryRect.right + gap);
      const right = Math.round(layoutRect.right);
      panelW = Math.max(MIN_PANEL_W, right - left);

      const top = VIEWPORT_TOP;
      panelH = Math.max(MIN_PANEL_H, vh - top - VIEWPORT_BOTTOM_MARGIN);

      panel.style.left = left + 'px';
      panel.style.top = top + 'px';
      panel.style.width = panelW + 'px';
      panel.style.height = panelH + 'px';

      lensW = panelW / ZOOM;
      lensH = panelH / ZOOM;
      if (activeImg) {
        const r = activeImg.getBoundingClientRect();
        const scale = Math.min(1, r.width / lensW, r.height / lensH);
        lensW = Math.floor(lensW * scale);
        lensH = Math.floor(lensH * scale);
      }
      lens.style.width = lensW + 'px';
      lens.style.height = lensH + 'px';
    };

    const positionLensAndBackground = (clientX, clientY) => {
      if (!activeImg) return false;
      const rect = activeImg.getBoundingClientRect();

      const x = clientX - rect.left;
      const y = clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        return false;
      }

      let lx = clientX - lensW / 2;
      let ly = clientY - lensH / 2;
      lx = Math.max(rect.left, Math.min(rect.right - lensW, lx));
      ly = Math.max(rect.top, Math.min(rect.bottom - lensH, ly));
      lens.style.left = lx + 'px';
      lens.style.top = ly + 'px';

      const ratioX = (lx - rect.left) / Math.max(1, rect.width - lensW);
      const ratioY = (ly - rect.top) / Math.max(1, rect.height - lensH);

      const bgW = (rect.width * panelW) / lensW;
      const bgH = (rect.height * panelH) / lensH;
      const bgX = -ratioX * (bgW - panelW);
      const bgY = -ratioY * (bgH - panelH);

      panel.style.backgroundSize = bgW + 'px ' + bgH + 'px';
      panel.style.backgroundPosition = bgX + 'px ' + bgY + 'px';
      return true;
    };

    const onLeave = () => {
      activeImg = null;
      activeSrc = null;
      lens.hidden = true;
      panel.hidden = true;
    };

    const syncActiveZoom = () => {
      if (!activeImg) return;
      sizePanelAndLens();
      if (!positionLensAndBackground(lastClientX, lastClientY)) {
        onLeave();
      }
    };

    const onEnter = (e) => {
      const item = e.currentTarget;
      const img = item.querySelector('img');
      if (!img || !item.dataset.src) return;

      activeImg = img;
      activeSrc = item.dataset.src;
      lastClientX = e.clientX;
      lastClientY = e.clientY;

      panel.style.backgroundImage = 'url("' + activeSrc + '")';
      sizePanelAndLens();
      positionLensAndBackground(lastClientX, lastClientY);
      lens.hidden = false;
      panel.hidden = false;
    };

    const onMove = (e) => {
      if (!activeImg) return;
      lastClientX = e.clientX;
      lastClientY = e.clientY;
      if (!positionLensAndBackground(lastClientX, lastClientY)) {
        onLeave();
      }
    };

    items.forEach((item) => {
      item.addEventListener('mouseenter', onEnter);
      item.addEventListener('mousemove', onMove);
      item.addEventListener('mouseleave', onLeave);
    });

    // Keep zoom alive across sticky-header scroll; only dismiss if pointer left the image.
    window.addEventListener('scroll', syncActiveZoom, { passive: true });
    window.addEventListener('resize', syncActiveZoom);
    document.addEventListener('header-height-change', syncActiveZoom);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
